import { useEffect } from 'react';
import { useNoDigitalCalendarStore } from './useNoDigitalCalendarStore';

interface UseNoDigitalSlotsProps {
  policyId: string;
  enabled?: boolean; 
}

export const useNoDigitalSlots = ({ policyId, enabled = false }: UseNoDigitalSlotsProps) => {
  const {
    slots,
    loading,
    error,
    errorType,
    selectedSlot,
    selectedSlotData,
    assigningSlot,
    isUsingMockData,
    fetchSlots,
    setSelectedSlot,
    assignSlot,
    clearSlots
  } = useNoDigitalCalendarStore();

  useEffect(() => {
    if (enabled && policyId) {
      fetchSlots(policyId);
    } else if (!enabled) {
      clearSlots();
    }
  }, [enabled, policyId, fetchSlots, clearSlots]);

  return {
    slots: enabled ? slots : [],
    loading: enabled ? loading : false,
    error: enabled ? error : null,
    errorType: enabled ? errorType : null,
    selectedSlot: enabled ? selectedSlot : null,
    selectedSlotData: enabled ? selectedSlotData : null,
    assigningSlot: enabled ? assigningSlot : false,
    isUsingMockData: enabled ? isUsingMockData : false,
    setSelectedSlot: enabled ? setSelectedSlot : () => {},
    assignSlot: () => assignSlot(policyId),
    refetch: () => fetchSlots(policyId)
  };
};